import { InMemoryCache } from "apollo-cache-inmemory";
import ApolloClient from "apollo-client";
import gql from "graphql-tag";
import { graphql, MutationFunc } from "react-apollo";
import { generateApolloLink } from "~/graphql/client";

const NEXUS_API_URL =
  process.env.NODE_ENV === "production"
    ? "https://api.nexusapp.co/nexus/storefront/graphql"
    : "https://api.nexusapp.test/nexus/storefront/graphql";

const nexusClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: generateApolloLink(NEXUS_API_URL)
});

export default nexusClient;

// ====================================================
// Form Statuses
// ====================================================
export enum FormStatus {
  FORM,
  FORM_LOADING
}

// ====================================================
// Order Number Validation State
// ====================================================
export enum OrderNumberValidationState {
  DEFAULT,
  LOADING,
  VALID,
  INVALID
}

// ====================================================
// Trengo Ticket Type
// ====================================================
export enum TicketType {
  CALLBACK_REQUEST = "CALLBACK_REQUEST",
  RMA_REQUEST = "RMA_REQUEST",
  CONTACT_REQUEST = "CONTACT_REQUEST"
}

// tslint:disable-next-line: interface-name
export interface CreateTicketVariables {
  input: CreateTicketInput;
}

// tslint:disable-next-line: interface-name
export interface TicketFields {
  reason?: string | null;
}

// tslint:disable-next-line: interface-name
export interface SubmitterFields {
  name: string | null;
  phone?: string | null;
}

// tslint:disable-next-line: interface-name
export interface CreateTicketInput {
  email: string | null;
  subject?: string | null;
  description: string | null;
  orderName?: string | null;
  zip?: string | null;
  type:
    | TicketType.CALLBACK_REQUEST
    | TicketType.RMA_REQUEST
    | TicketType.CONTACT_REQUEST;

  submitter: SubmitterFields;
  rmaRequest?: TicketFields;
}

export interface ICreateTicketProps {
  createTicket: MutationFunc<CreateTicketVariables>;
}

export const CREATE_TICKET_MUTATION = gql`
  mutation TicketCreate($input: TicketCreateInput!) {
    ticketCreate(input: $input) {
      ticket {
        id
        type
        name
      }
    }
  }
`;

export const withCreateTicketMutation = graphql(CREATE_TICKET_MUTATION, {
  name: "createTicket"
});



// WEBPACK FOOTER //
// ./src/graphql/mutations/trengoTicket/createTrengoTicket.ts